/* LP- landing page behavior: FAQ accordion + multi-scent add-to-cart. Scoped to layout/landing-page.liquid only. */
(function () {
  'use strict';

  function initAccordions() {
    document.querySelectorAll('.lp-accordion').forEach(function (accordion) {
      accordion.addEventListener('click', function (e) {
        var head = e.target.closest('.lp-accordion__head');
        if (!head) return;
        var item = head.closest('.lp-accordion__item');
        var wasOpen = item.classList.contains('is-open');
        accordion.querySelectorAll('.lp-accordion__item.is-open').forEach(function (open) {
          if (open !== item) open.classList.remove('is-open');
        });
        item.classList.toggle('is-open', !wasOpen);
      });
    });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initScentSelectors() {
    document.querySelectorAll('[data-lp-scent-selector]').forEach(function (root) {
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-lp-scent-row]'));
      var totalEl = root.querySelector('[data-lp-total]');
      var addBtn = root.querySelector('[data-lp-add-all]');
      var msgEl = root.querySelector('[data-lp-cart-msg]');

      function recalc() {
        var total = 0;
        var count = 0;
        rows.forEach(function (row) {
          var qty = parseInt(row.querySelector('[data-lp-qty-input]').value, 10) || 0;
          var price = parseInt(row.getAttribute('data-price-cents'), 10) || 0;
          total += qty * price;
          count += qty;
        });
        if (totalEl) totalEl.textContent = money(total);
        if (addBtn) addBtn.disabled = count === 0;
      }

      rows.forEach(function (row) {
        var input = row.querySelector('[data-lp-qty-input]');
        var minus = row.querySelector('[data-lp-qty-minus]');
        var plus = row.querySelector('[data-lp-qty-plus]');

        minus.addEventListener('click', function () {
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
          recalc();
        });
        plus.addEventListener('click', function () {
          input.value = Math.min(99, (parseInt(input.value, 10) || 0) + 1);
          recalc();
        });
        input.addEventListener('input', function () {
          var v = parseInt(input.value, 10);
          if (isNaN(v) || v < 0) v = 0;
          input.value = v;
          recalc();
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var items = [];
          rows.forEach(function (row) {
            var qty = parseInt(row.querySelector('[data-lp-qty-input]').value, 10) || 0;
            if (qty > 0) {
              items.push({ id: row.getAttribute('data-variant-id'), quantity: qty });
            }
          });
          if (!items.length) return;

          addBtn.disabled = true;
          var originalText = addBtn.textContent;
          addBtn.textContent = 'Adding…';
          if (msgEl) msgEl.textContent = '';

          fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              if (!res.ok) return res.json().then(function (err) { throw err; });
              return res.json();
            })
            .then(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
              if (msgEl) msgEl.textContent = 'Added to your cart.';
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            })
            .catch(function (err) {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
              if (msgEl) msgEl.textContent = (err && err.description) || 'Something went wrong — try again.';
            });
        });
      }

      var mainImage = root.querySelector('[data-lp-main-image]');
      var thumbsWrap = root.querySelector('[data-lp-thumbs]');

      function setActiveThumb(thumb) {
        if (!thumbsWrap) return;
        thumbsWrap.querySelectorAll('[data-lp-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      }

      // Event delegation: thumbnail rail is rebuilt when a scent is focused, so bind once on the wrapper.
      if (thumbsWrap) {
        thumbsWrap.addEventListener('click', function (e) {
          var thumb = e.target.closest('[data-lp-thumb]');
          if (!thumb) return;
          setActiveThumb(thumb);
          var url = thumb.getAttribute('data-image-url');
          if (mainImage && url) mainImage.setAttribute('src', url);
        });
      }

      function focusScent(row) {
        var media = [];
        try {
          media = JSON.parse(row.getAttribute('data-media') || '[]');
        } catch (err) {
          media = [];
        }
        if (!media.length || !thumbsWrap) return;

        rows.forEach(function (r) { r.classList.remove('is-focused'); });
        row.classList.add('is-focused');

        if (mainImage) mainImage.setAttribute('src', media[0].url);
        if (mainImage) mainImage.setAttribute('alt', row.getAttribute('data-title') || '');

        thumbsWrap.innerHTML = '';
        media.forEach(function (item, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'lp-buy__thumb' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('data-lp-thumb', '');
          btn.setAttribute('data-image-url', item.url);
          btn.setAttribute('aria-label', (row.getAttribute('data-title') || '') + ' photo ' + (i + 1));
          var img = document.createElement('img');
          img.src = item.thumb || item.url;
          img.alt = '';
          img.loading = 'lazy';
          btn.appendChild(img);
          thumbsWrap.appendChild(btn);
        });
      }

      rows.forEach(function (row) {
        row.addEventListener('click', function (e) {
          if (e.target.closest('.lp-qty')) return; // don't hijack qty stepper clicks
          focusScent(row);
        });
      });

      recalc();
    });
  }

  function initAnchorButtons() {
    document.querySelectorAll('[data-lp-scroll-to]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var targetSel = btn.getAttribute('data-lp-scroll-to');
        var target = targetSel && document.querySelector(targetSel);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAccordions();
    initScentSelectors();
    initAnchorButtons();
  });
})();
